import { useEffect } from 'react';

const useAvoidKeyboardView = () => {
  const initialHeight = window.innerHeight;
  const initialWidth = window.innerWidth;

  const handleResizeConstanted = () => {
    const currentHeight = window.innerHeight;
    const currentWidth = window.innerWidth;

    let newHeight = initialHeight;

    if (currentHeight !== initialHeight && currentWidth !== initialWidth) {
      newHeight = currentWidth;
    }

    const metaViewport = document.querySelector('meta[name=viewport]');
    metaViewport.setAttribute('content',
      `height=${newHeight}px, width=device-width, initial-scale=1.0`);
  };

  useEffect(() => {
    window.addEventListener('resize',
      handleResizeConstanted);

    return () => {
      window.removeEventListener('resize',
        handleResizeConstanted);
    };
  }, []);
};

export { useAvoidKeyboardView };
